import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AppIcon } from '../icons';
import { AvatarContainer } from './avatar';
export const AvatarIcon = ({ icon, backgroundColor, size, fillColor, avatarSize = 'small', ...otherProps }) => {
    const content = _jsx(AppIcon, { name: icon, size: size, color: fillColor ?? 'white' });
    return (_jsx(AvatarContainer, { size: avatarSize, backgroundColor: backgroundColor, ...otherProps, children: content }));
};
//# sourceMappingURL=avatar_icon.js.map